module.exports = {
    apiUrl: 'http://app.fazendoacontecer.org.br/api'
}